import { createAction } from "@reduxjs/toolkit";
import { CHAT_ACTIONS } from "../../types";

export const readMessage = createAction(
  CHAT_ACTIONS.READ_MESSAGE,
  (messageId: string) => ({
    payload: { messageId },
  })
);
